import GenerateSlug from '@/plugin/generateSlug'

export default class CaseStudiesRoute extends GenerateSlug<{
  location: string
  industry: string
  page: number | null
}> {
  constructor() {
    super({
      location: '',
      industry: '',
      page: null,
    })
  }
}
